module.exports = __webpack_public_path__ + "apple.png";